if (!customElements.get('adev-product-block-flavors')) {
    customElements.define('adev-product-block-flavors', class adevProductBlockFlavors extends HTMLElement {
        constructor() {
            super();
        }

        onClickItem(event) {
            const item = event.currentTarget;
            const itemId = item.getAttribute('data-id');

            const mediaGallery = document.querySelector('adev-product-media-gallery');
            if (!mediaGallery) return;

            const itemEl = mediaGallery.querySelector(`[data-adev-main-product="media-gallery-item"][data-media-alt="FITB-${itemId}"]`);
            if (!itemEl) return;
            
            mediaGallery.dispatchEvent(new CustomEvent('adev:media-gallery:update', {
                detail: {
                    index: itemEl.dataset.index,
                }
            }));
        }

        connectedCallback() {
            this.querySelectorAll('[data-adev-product-block-flavors="item"]').forEach(item => {
                item.addEventListener('click', this.onClickItem.bind(this));
            });
        }

        disconnectedCallback() {
            this.querySelectorAll('[data-adev-product-block-flavors="item"]').forEach(item => {
                item.removeEventListener('click', this.onClickItem.bind(this));
            });
        }

    });
}